module.exports = __webpack_public_path__ + "media/app/assets/races/undead_female-079ebf0cd7c36582efa2181ae54b714a.png";